import request from '@/utils/request'

let DocumentApi = {

  /*操作文档列表*/
  list(data) {
    return request._post('/shop/plus.document.Index/index', data);
},
/*添加操作文档*/
add(data) {
    return request._post('/shop/plus.document.Index/add', data);
},
/*修改操作文档*/
edit(data) {
    return request._post('/shop/plus.document.Index/edit', data);
},
/*删除操作文档*/
del(data) {
    return request._post('/shop/plus.document.Index/del', data);
},
/*操作文档详情*/
detail(data) {
  return request._post('/shop/plus.document.Index/detail', data);
},
/*文档前端*/
search(data) {
    return request._post('/shop/plus.document.Index/search', data);
  },
  /*文档前端*/
searchDetail(data) {
    return request._post('/shop/plus.document.Index/searchDetail', data);
  },
    saveSetting(data, errorback) {
        return request._post('/shop/plus.document.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.document.Setting/getSetting', data, errorback);
    },
}
export default DocumentApi;



// WEBPACK FOOTER //
// ./src/api/document.js